import React, { useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ErrorDashboard = () => {
  const navigate = useNavigate();

  // Function to navigate to the home page
  const goHome = () => {
    navigate('/');
  };

  useEffect(() => {
    // Warn on refresh or back button and redirect to the home page
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // Show a generic confirmation message
      navigate('/');
    };

    // Attach event listener for page refresh or back button
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Redirect if user navigates back
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      navigate('/');
    };

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.onpopstate = null;
    };
  }, [navigate]);

  return (
    <Box
      sx={{
        height: '100vh', // Full viewport height
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: '#f0f0f0', // Light gray background
        padding: '20px',
      }}
    >
      {/* Animated SVG Icon */}
      <Box
        component="div"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '20px',
          animation: 'spin 4s linear infinite',
          '@keyframes spin': {
            '0%': {
              transform: 'rotate(0deg)',
            },
            '100%': {
              transform: 'rotate(360deg)',
            },
          },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="100px"
          viewBox="0 0 24 24"
          width="100px"
          fill="#114C78" // Icon color
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z" />
        </svg>
      </Box>

      {/* Extra large 404 text with new font */}
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '6rem', md: '10rem' }, // Extra large font size
          fontWeight: 'bold',
          color: '#114C78', // Primary color
          fontFamily: '"Roboto Slab", serif', // New font family
          textShadow: '4px 4px 8px rgba(0, 0, 0, 0.3)', // Add a slight shadow for impact
        }}
      >
        404
      </Typography>

      {/* Page not found text */}
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: '1.5rem', md: '2rem' },
          marginBottom: '20px',
          color: '#555', // Subtle text color
        }}
      >
        Page Not Found
      </Typography>

      {/* Go Home button */}
      <Button
        variant="contained"
        color="primary"
        onClick={goHome}
        sx={{
          padding: '10px 20px',
          fontSize: '1rem',
          backgroundColor: '#114C78', // Custom button color
          '&:hover': {
            backgroundColor: '#0d3a59', // Darker on hover
          },
        }}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default ErrorDashboard;
